module.exports = __webpack_public_path__ + "static/img/2_25.ac516ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/2_25.jpg
// module id = vEY2
// module chunks = 1